import { render, staticRenderFns } from "./BacktopButton.vue?vue&type=template&id=b9ba6bec&scoped=true&"
import script from "./BacktopButton.vue?vue&type=script&lang=js&"
export * from "./BacktopButton.vue?vue&type=script&lang=js&"
import style0 from "./BacktopButton.vue?vue&type=style&index=0&id=b9ba6bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba6bec",
  null
  
)

export default component.exports